<template>
    <x-page :title="pageTitle">
        <template #header-actions>
            <x-back-button :disabled="isLoading" :display-warning="false" />
        </template>

        <ul id="member-tabs" class="nav nav-tabs">
            <li role="presentation" class="active">
                <a
                    href="#member-detail"
                    aria-controls="member-detail"
                    role="tab"
                    data-toggle="tab"
                    >Biodata</a
                >
            </li>
            <li role="presentation">
                <a
                    href="#member-milestone"
                    aria-controls="member-milestone"
                    role="tab"
                    data-toggle="tab"
                    >Journey</a
                >
            </li>
            <li role="presentation">
                <a
                    href="#group"
                    aria-controls="group"
                    role="tab"
                    data-toggle="tab"
                    >Group</a
                >
            </li>
            <li role="presentation" v-if="isKid">
                <a
                    href="#member-guardian"
                    aria-controls="member-guardian"
                    role="tab"
                    data-toggle="tab"
                    >Guardian</a
                >
            </li>
            <li role="presentation" v-if="shouldDisplayPotentialMember">
                <a
                    href="#potential-member"
                    aria-controls="potential-member"
                    role="tab"
                    data-toggle="tab"
                    >Hello Form</a
                >
            </li>
            <li role="presentation">
                <a
                    href="#family-tree"
                    aria-controls="family-tree"
                    role="tab"
                    data-toggle="tab"
                    >Family Tree</a
                >
            </li>
        </ul>

        <div class="tab-content" style="padding-top: 10px">
            <div
                role="tabpanel"
                class="tab-pane fade in active"
                id="member-detail"
            >
                <member-form
                    id="member-form"
                    v-if="resource"
                    :display-id="true"
                    :display-join-date="false"
                    :displayCode="true"
                    :disabled="true"
                    :initialFields="resource"
                />
            </div>

            <div
                role="tabpanel"
                class="tab-pane fade section-history"
                id="member-milestone"
            >
                <member-milestones
                    v-if="Boolean(resource)"
                    :value="resource.milestones"
                    :readonly="true"
                />
            </div>

            <div
                role="tabpanel"
                class="tab-pane fade"
                id="group"
                v-if="Boolean(resource)"
            >
                <x-table
                    :headers="['Group', 'Jml Anggota', 'Role']"
                    :is-loading="isLoading"
                >
                    <tr v-for="(group, index) in resource.groups" :key="index">
                        <td>
                            <router-link
                                v-if="can('viewGroups')"
                                :to="`/admin/groups/${group.id}`"
                            >
                                {{ group.label }}
                            </router-link>
                            <span v-else>{{ group.label }}</span>
                            <x-sms-blast-label
                                v-if="
                                    group.category &&
                                    group.category.sms_birthday_blast
                                "
                            />
                        </td>
                        <td>{{ group.members_count | number }}</td>
                        <td>
                            {{ getRoleIn(group) | get("label", "Anggota") }}
                        </td>
                    </tr>
                </x-table>
            </div>

            <div
                role="tabpanel"
                class="tab-pane fade"
                id="potential-member"
                v-if="shouldDisplayPotentialMember"
            >
                <potential-member-form
                    id="potential-member-form"
                    :disabled="true"
                    :initialFields="resource.potential_member"
                />
            </div>

            <div
                role="tabpanel"
                class="tab-pane fade"
                id="member-guardian"
                v-if="isKid"
            >
                <member-guardian-form
                    id="member-guardian-form"
                    v-if="resource"
                    v-model="resource.guardians"
                    :disabled="true"
                    :errors="errors"
                />
            </div>

            <div role="tabpanel" class="tab-pane fade" id="family-tree">
                <x-family-tree :data="familyTree" v-if="renderFamilyTree" />
            </div>
        </div>
    </x-page>
</template>

<script>
import XBackButton from "../../components/XBackButton.vue";
import XPage from "../../components/XPage.vue";
import XTable from "../../components/XTable.vue";
import { memberStatus } from "../../constants";
import { formatForDateInput, handleGeneralXhrError } from "../../helpers";
import PotentialMemberForm from "../potential-member/PotentialMemberForm.vue";
import MemberForm from "./MemberForm.vue";
import MemberGuardianForm from "./MemberGuardianForm.vue";
import XFamilyTree from "../../components/XFamilyTree.vue";
import XSmsBlastLabel from "../../components/XSmsBlastLabel.vue";
import PermissionMixin from "../../mixins/PermissionMixin";
import MemberMilestones from "./MemberMilestones.vue";

export default {
    components: {
        XPage,
        XBackButton,
        MemberForm,
        PotentialMemberForm,
        XTable,
        MemberGuardianForm,
        XFamilyTree,
        XSmsBlastLabel,
        MemberMilestones,
    },
    computed: {
        shouldDisplayPotentialMember() {
            return (
                Boolean(this.resource) &&
                Boolean(this.resource.potential_member)
            );
        },
        isKid() {
            return _.get(this.resource, "status") == memberStatus.kid;
        },
        pageTitle() {
            let title = ["Detail Jemaat"];

            if (this.resource) {
                title.push(this.resource.name);
            }

            return title.join(" | ");
        },
    },
    created() {
        this.fetchResource();
        this.fetchFamilyTree();
    },
    data() {
        return {
            errors: null,
            familyTree: null,
            isLoading: false,
            renderFamilyTree: false,
            resource: null,
        };
    },
    methods: {
        activateTabs() {
            const context = this;

            $("#member-tabs a").click(function (e) {
                e.preventDefault();
                $(this).tab("show");
            });

            $("#member-tabs a").on("shown.bs.tab", function (e) {
                if ($(this).attr("href") == "#family-tree") {
                    context.renderFamilyTree = true;
                } else {
                    context.renderFamilyTree = false;
                }
                $(".matchHeight").matchHeight();
            });
        },
        fetchFamilyTree() {
            this.isLoading = true;
            const request = axios
                .get(`/api/members/${this.$route.params.id}/family-tree`)
                .then((response) => {
                    this.familyTree = response.data.data;
                });
            return handleGeneralXhrError(request).finally(() => {
                this.isLoading = false;
            });
        },
        fetchResource() {
            this.isLoading = true;
            const request = axios
                .get(`/api/members/${this.$route.params.id}`, {
                    params: {
                        load: [
                            "groups.category",
                            "guardians.member_account",
                            "milestones",
                            "potential_member",
                            "roles",
                            "user_account",
                        ],
                    },
                })
                .then((response) => {
                    const resource = response.data.data;
                    this.resource = {
                        ...resource,
                        birthdate: formatForDateInput(resource.birthdate),
                        guardians: resource.guardians.map(
                            ({ pivot, ...guardian }) => ({
                                ...pivot,
                                guardian,
                            })
                        ),
                        join_date: formatForDateInput(resource.join_date),
                        milestones: _.sortBy(resource.milestones, "created_at"),
                        potential_member: Boolean(resource.potential_member)
                            ? {
                                  ...resource.potential_member,
                                  birthdate: formatForDateInput(
                                      resource.potential_member.birthdate
                                  ),
                              }
                            : null,
                    };
                });
            return handleGeneralXhrError(request).finally(() => {
                this.isLoading = false;
            });
        },
        getRoleIn(group) {
            if (!Boolean(this.resource)) {
                return null;
            }

            return this.resource.roles.find(
                (role) => role.id == group.pivot.role_id
            );
        },
    },
    mixins: [PermissionMixin],
    mounted() {
        this.activateTabs();
    },
};
</script>
